import { render, staticRenderFns } from "./verifyResendCaptcha.vue?vue&type=template&id=ccca31cc&scoped=true"
import script from "./verifyResendCaptcha.vue?vue&type=script&lang=js"
export * from "./verifyResendCaptcha.vue?vue&type=script&lang=js"
import style0 from "./verifyResendCaptcha.vue?vue&type=style&index=0&id=ccca31cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccca31cc",
  null
  
)

export default component.exports